import React, { useEffect, useState } from 'react';
import GenericCRUDPage from '../../components/GenericCRUDPage';
import { FormField, Input, Select, Badge } from '../../components/UI';
import { userService, roleService, branchService } from '../../api/services';
import { toJalali } from '../../utils/jalali';

const UserFormFields = ({ form: { register }, editItem }) => {
  const [roles, setRoles] = useState([]);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    roleService.getAll({ limit: 100 }).then(r => setRoles(r.data.data || []));
    branchService.getAll({ limit: 100 }).then(r => setBranches(r.data.data || []));
  }, []);

  return (
    <div className="grid grid-cols-2 gap-4">
      <FormField label="Full Name" required>
        <Input {...register('name', { required: 'Required' })} placeholder="Full name" />
      </FormField>
      <FormField label="Email" required>
        <Input type="email" {...register('email', { required: 'Required' })} placeholder="email@pharmacy.com" />
      </FormField>
      {!editItem && (
        <FormField label="Password" required>
          <Input type="password" {...register('password', { required: !editItem })} placeholder="Password" />
        </FormField>
      )}
      <FormField label="Phone">
        <Input {...register('phone')} placeholder="+93 700 000 000" />
      </FormField>
      <FormField label="Role" required>
        <Select {...register('role', { required: 'Required' })}>
          <option value="">Select role</option>
          {roles.map(r => <option key={r._id} value={r._id}>{r.name}</option>)}
        </Select>
      </FormField>
      <FormField label="Branch">
        <Select {...register('branch')}>
          <option value="">All Branches</option>
          {branches.map(b => <option key={b._id} value={b._id}>{b.name}</option>)}
        </Select>
      </FormField>
    </div>
  );
};

const columns = [
  { key: 'name', label: 'Name', sortable: true },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'role', label: 'Role', render: (v) => v?.name ? <Badge color="blue">{v.name}</Badge> : '-' },
  { key: 'branch', label: 'Branch', render: (v) => v?.name || 'All' },
  { key: 'lastLogin', label: 'Last Login', render: (v) => v ? toJalali(v) : 'Never' },
  { key: 'isActive', label: 'Status', render: (v) => <Badge color={v ? 'green' : 'gray'}>{v ? 'Active' : 'Inactive'}</Badge> },
];

export default function UsersPage() {
  return (
    <GenericCRUDPage
      title="Users"
      subtitle="Manage system users"
      service={userService}
      entityName="User"
      columns={columns}
      FormFields={UserFormFields}
      modalSize="lg"
    />
  );
}
